import ImageViewer from '~/rapid_diffs/app/image_viewer/image_viewer.vue';
import DiffDiscussions from '../discussions/diff_discussions.vue?vue3';
import DraftNote from '../discussions/draft_note.vue?vue3';
import BaseImageDiffOverlay from '../../../diffs/components/base_image_diff_overlay.vue?vue3';
import NoteForm from '../discussions/note_form.vue?vue3';
import { clearDraft } from '~/lib/utils/autosave';
export default {
    name: 'ImageDiffViewerWithDiscussions',
    components: {
        NoteForm,
        BaseImageDiffOverlay,
        DiffDiscussions,
        DraftNote,
        ImageViewer
    },
    inject: {
        store: {
            type: Object
        },
        userPermissions: {
            type: Object
        }
    },
    props: {
        imageData: {
            type: Object,
            required: true
        },
        oldPath: {
            type: String,
            required: false,
            default: null
        },
        newPath: {
            type: String,
            required: false,
            default: null
        },
        diffRefs: {
            type: Object,
            required: false,
            default: null
        }
    },
    data () {
        return {
            commentForm: null
        };
    },
    computed: {
        canStartReview () {
            return Boolean(this.store.createDraftImageDiscussion);
        },
        autosaveKey () {
            return `${window.location.pathname}-image-${[
                this.oldPath || '-',
                this.newPath || '-'
            ].join('-')}`;
        },
        discussions () {
            return this.store.findAllImageDiscussionsForFile({
                oldPath: this.oldPath,
                newPath: this.newPath,
                diffRefs: this.diffRefs
            });
        },
        publishedDiscussions () {
            return this.discussions.filter((discussion)=>!discussion.isDraft);
        },
        drafts () {
            return this.discussions.filter((discussion)=>discussion.isDraft);
        }
    },
    methods: {
        openForm (data) {
            this.commentForm = {
                noteBody: this.commentForm ? this.commentForm.noteBody : '',
                ...data
            };
        },
        commentPosition () {
            return {
                ...this.diffRefs,
                old_path: this.oldPath,
                new_path: this.newPath,
                position_type: 'image',
                width: this.commentForm.width,
                height: this.commentForm.height,
                x: this.commentForm.x,
                y: this.commentForm.y
            };
        },
        closeForm () {
            clearDraft(this.autosaveKey);
            this.commentForm = null;
        },
        async saveNote (noteBody) {
            await this.store.createImageDiscussion({
                position: this.commentPosition(),
                noteBody
            });
            this.closeForm();
        },
        async saveDraft (noteBody) {
            await this.store.createDraftImageDiscussion({
                position: this.commentPosition(),
                noteBody
            });
            this.closeForm();
        }
    }
};
